import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class EventManagementService {
  constructor(private http: HttpClient) {}

  Controller = 'Event'
  getEvents(body: any) {
    return this.http.post(`${this.Controller}/Search`, body)
  }

  getArchiveEvent(body: any) {
    return this.http.post(`${this.Controller}/Archive`, body)
  }

  addEvent(body: any) {
    return this.http.post(`${this.Controller}/CreateEvent`, body)
  }

  updateEvent(body: any) {
    return this.http.put(`${this.Controller}/UpdateEvent`, body)
  }

  deleteEvent(id: any) {
    return this.http.delete(`${this.Controller}/DeleteEvent/${id}`)
  }
  undoEvent(id: any) {
    return this.http.post(`${this.Controller}/Undo/${id}`, {})
  }

  getEventById(id: any) {
    return this.http.get(`${this.Controller}/GetEvent/${id}`)
  }
  getLinkedDocument(body: any) {
    return this.http.post(`${this.Controller}/LinkedDocuments`, body)
  }
  getEventVersions(id: any) {
    return this.http.get(`${this.Controller}/GetVersions/${id}`)
  }
  activateEvent(id: any) {
    return this.http.post(`${this.Controller}/Activate?id=${id}`, {})
  }
  deactivateEvent(id: any) {
    return this.http.post(`${this.Controller}/DeActivate?id=${id}`, {})
  }

  addFrequency(data: any) {
    return this.http.post(`${this.Controller}/Frequency`, data)
  }
  getFrequencyById(id: any) {
    return this.http.get(`${this.Controller}/Frequency/${id}`)
  }
}
